// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__+qCUU","wrapper_img":"styles_wrapper_img__54Ymf"};